export enum ActionType {
  left = "left",
  right = "right",
}
